import React, { useState, useEffect } from "react";
import SpeAccDataService from "../services/SpeAccService";

const SpeAcc = props => {
  const initialSpeAccState = {
    amount: "",
    previousBalance: "",
    newBalance: ""
  };
  const [currentSpeAcc, setCurrentSpeAcc] = useState(initialSpeAccState);
  const [message, setMessage] = useState("");

  const getSpeAcc = id => {
    SpeAccDataService.get(id)
      .then(response => {
        setCurrentSpeAcc(response.data);
        console.log(response.data);
      })
      .catch(e => {
        console.log(e);
      });
  };

  useEffect(() => {
    getSpeAcc(props.match.params.id);
  }, [props.match.params.id]);

  const handleInputChange = event => {
    const { name, value } = event.target;
    setCurrentSpeAcc({ ...currentSpeAcc, [name]: value });
  };

  const updateSpeAcc = () => {
    SpeAccDataService.update(currentSpeAcc.id, currentSpeAcc)
      .then(response => {
        console.log(response.data);
        setMessage("Special Account transactions was updated successfully!");
      })
      .catch(e => {
        console.log(e);
      });
  };

  const deleteSpeAcc = () => {
    SpeAccDataService.remove(currentSpeAcc.id)
      .then(response => {
        console.log(response.data);
        props.history.push("/speacc");
      })
      .catch(e => {
        console.log(e);
      });
  };

  return (
    <div>
      {currentSpeAcc ? (
        <div className="edit-form">
          <h4>Special Account Transactions</h4>
          <form>
            <div className="form-group">
              <label htmlFor="amount">Amount</label>
              <input
                type="text"
                className="form-control"
                id="amount"
                name="amount"
                value={currentSpeAcc.amount}
                onChange={handleInputChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="previousBalance">Previous Balance</label>
              <input
                type="text"
                className="form-control"
                id="previousBalance"
                name="previousBalance"
                value={currentSpeAcc.previousBalance}
                onChange={handleInputChange}
              />
            </div>

            <div className="form-group">
              <label htmlFor="newBalance">New Balance</label>
              <input
                type="text"
                className="form-control"
                id="newBalance"
                name="newBalance"
                value={currentSpeAcc.newBalance}
                onChange={handleInputChange}
              />
            </div>
          </form>      

          <button className="badge badge-danger mr-2" onClick={deleteSpeAcc}>
            Delete
          </button>

          <button
            type="submit"
            className="badge badge-success"
            onClick={updateSpeAcc}
          >
            Update
          </button>
          <p>{message}</p>
        </div>
      ) : (
        <div>
          <br />
          <p>Please click on a Special Account Transaction...</p>
        </div>
      )}
    </div>
  );
};

export default SpeAcc;
